module.exports = __webpack_public_path__ + "static/media/m-hive.553a3f35.pdf";